module.exports = __webpack_public_path__ + "static/media/sortingdown-theme.f0fd626e.svg";